<template>
    <div>
        <article-multiple-desktop-page v-if="isDesktopVersion()"></article-multiple-desktop-page>
        <article-multiple-page v-else-if="$root.template === 'video_template' || $root.template === 'slider_template'"></article-multiple-page>
        <article-single-page v-else></article-single-page>
    </div>
</template>

<script>
import ArticleMultiplePage from "./ArticleMultiplePage";
import ArticleMultipleScrollPage from "./ArticleMultipleScrollPage";
import ArticleSinglePage from "./ArticleSinglePage.vue";
import ArticleMultipleDesktopPage from "./ArticleMultipleDesktopPage.vue";

export default {
    name: "HomeNewIndex",

    components: {
        ArticleMultiplePage,
        ArticleMultipleScrollPage,
        ArticleSinglePage,
        ArticleMultipleDesktopPage
    },
}

</script>